<template>
  <div class="TripDetail">
    <header>
      <div class="top">
        <span class="iconfont icon-home" @click="GoHome"></span>
        <span @click="GoHome">首页</span>
        <span @click="LoginOut">退出</span>
        <span class="iconfont icon-loginOut" @click="LoginOut"></span>
      </div>
      <div class="center">
        <span v-text="trip.TripName"></span>
        <span v-text="'游玩天数：' + trip.TripDays + '（天）'"></span>
        <span v-text="'游玩人数：' + trip.TrousitCount + '（人）'"></span>
        <span v-text="'备案时间：' + trip.PostTime"></span>
        <span v-text="'开始时间：' + trip.StartTime"></span>
      </div>
      <div class="bottom">
        <div>
          如发现行程信息与行程单不符，并有强制购物，变更行程等行为，请立即投诉。
        </div>
        <div><a href="tel:12345">在线投诉</a></div>
      </div>
    </header>

    <div class="main">
      <div class="mainScroll" id="mainList">

        <div class="trip">
          <div class="title">
            <span class="iconfont icon-iconTrip"></span>
            <span>行程信息</span>
            <span class="iconfont icon-warn"></span>
          </div>
          <div class="title" style="margin-top:10px;" v-if="trip.RemarkTrip&&trip.RemarkTrip!=undefined&&trip.RemarkTrip!=null&&trip.RemarkTrip!=''">
            <span>行程备注：{{trip.RemarkTrip}}</span>
          </div>
          <div class="calendar">
            <div class="item" v-for="(item, index) in line" @click="SelectDate(index)">
              <span v-text="GetWeek(item.week)" class="week"></span>
              <div class="date" v-bind:class="{
                tripDate: true,
                active: selectDate == index ? true : false
              }">
                <span v-text="item.date"></span>
                <span class="iconfont icon-point"></span>
              </div>
            </div>
          </div>

          <div class="swiper">
            <div class="swiper-container">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item, dayIndex) in line">
                  <div class="item" v-if="dayIndex == 0">
                    <span class="line"></span>
                    <div class="iconfont icon-point"></div>
                    <div class="con">
                      <span v-text="trip.StartPoint"></span>
                      <span v-text="'(起点)'"></span>
                    </div>
                    <div class="time">
                      <span></span>
                      <span>——</span>
                    </div>
                  </div>

                  <div :class="{ item: true, black: i.Status == 0 ? true : false }" v-for="(i, index) in item.router">
                    <span class="line" v-if="
                      index != item.router.length - 1 ||
                      dayIndex == line.length - 1
                    "></span>
                    <div :class="{
                      iconfont: true,
                      'icon-point': true,
                      blue: i.Status == 0 ? true : false
                    }"></div>
                    <div class="con">
                      <span v-text="i.Projects"></span>
                      <span v-text="'(' + i.PointType + ')'"></span>
                    </div>
                    <div class="time">
                      <span v-text="i.IsZiFei ? '自费' : ''"></span>
                      <span v-text="i.TimeSpan + '分钟'"></span>
                    </div>
                  </div>

                  <div class="item" v-if="dayIndex == line.length - 1">
                    <div class="iconfont icon-point"></div>
                    <div class="con">
                      <span v-text="trip.EndPoint"></span>
                      <span v-text="'(终点)'"></span>
                    </div>
                    <div class="time">
                      <span></span>
                      <span>——</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 如果需要分页器 -->
              <div class="swiper-pagination" slot="pagination"></div>
            </div>
          </div>
        </div>

        <div class="contact" @click="GoEcontact(trip.OrderId)">
          <div class="title">
            <span class="iconfont icon-contact"></span>
            <span>电子合同</span>
            <span>点击可查看详细信息</span>
          </div>
          <div class="con">
            <span>合同名称</span>
            <span>苏州旅游电子合同</span>
          </div>
        </div>

        <div class="guide" v-for="item in guide">
          <div class="title">
            <span class="iconfont icon-guide"></span>
            <span>导游信息</span>
          </div>
          <div class="row">
            <span>导游姓名</span>
            <span v-text="item.Name"></span>
          </div>
          <div class="row">
            <span>导游证号</span>
            <span v-text="item.IDNumber"></span>
          </div>
        </div>

        <div class="car" v-show="trip.IsSelf === '0'">
          <div class="title">
            <span class="iconfont icon-bus"></span>
            <span>车辆信息</span>
          </div>
          <div class="row" v-for="item in bus">
            <span>车牌号</span>
            <span v-text="item.PlateNumber"></span>
          </div>
        </div>
        <div class="car" v-show="trip.IsSelf === '1'">
          <div class="title">
            <span class="iconfont icon-bus"></span>
            <span>车辆信息</span>
          </div>
          <div class="row" v-for="item in selfBus">
            <span>车牌号</span>
            <span v-text="item.selfPlateNumber"></span>
          </div>
        </div>

        <div class="car" v-show="trip.IsSelf === '0'">
          <div class="title">
            <span class="iconfont icon-bus"></span>
            <span>司机信息</span>
          </div>
          <div class="row" v-for="item in driver">
            <span>司机</span>
            <span v-text="item.Name"></span>
          </div>
        </div>
        <div class="car" v-show="trip.IsSelf === '1'">
          <div class="title">
            <span class="iconfont icon-bus"></span>
            <span>司机信息</span>
          </div>
          <div class="row" v-for="item in selfBus">
            <span>司机</span>
            <span v-text="item.selfDriverName"></span>
          </div>
        </div>

        <div class="corp">
          <div class="title">
            <span class="iconfont icon-tripCorp"></span>
            <span>门店/企业</span>
          </div>
          <div class="row">
            <span>签约门店/企业</span>
            <span v-text="trip.StoreId == null ? company.Name : trip.StoreName"></span>
          </div>
          <div class="row">
            <span>经营地址</span>
            <span v-text="company.Address"></span>
          </div>

          <div class="row">
            <span>经办人</span>
            <span v-text="trip.AgentName"></span>
          </div>

          <div class="row">
            <span>电话</span>
            <span v-text="company.Tel != '' ? company.Tel : company.Tel1"></span>
          </div>

          <div class="row">
            <span>签约时间</span>
            <span v-text="trip.SignTime"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
var mySwiper;

export default {
  data() {
    return {
      tripId: "",
      selectDate: 0,
      trip: {},
      bus: {},
      guide: {},
      driver: {},

      selfBus: {},

      line: {},
      company: {},
      totalTourist: 0
    };
  },
  methods: {
    GoEcontact(Id) {
      let _self = this;
      sessionStorage.setItem("Vue_OrderId", Id)
      _self.$router.push({
        name: 'Econtact',
        params: {
          orderId: Id
        }
      })
    },
    SelectDate(index) {
      let _self = this;
      _self.selectDate = index;
      mySwiper.slideTo(index, 500, false); //切换到第一个slide，速度为1秒
    },
    LoginOut() {
      let _self = this;
      _self.$root.LoginOut();
    },
    GoHome() {
      let _self = this;
      _self.$router.push("/HomePage");
    },
    GetData() {
      let _self = this;
      let param = {
        tripId: _self.tripId
      };
      _self.axios
        .post("/api/tourist/Itineraries/GetItinerariesDetail", param)
        .then(res => {
          _self.trip = res.data.trip;
          _self.bus = res.data.bus;
          _self.driver = res.data.driver;
          _self.guide = res.data.guide;
          _self.selfBus = res.data.selfBus;
          _self.line = res.data.router;
          _self.company = res.data.company;
        })
        .catch(err => { });
    },
    GetWeek(obj) {
      let _self = this;
      return _self.$root.GetWeekDay(obj);
    }
  },
  mounted() {
    let _self = this;
    if (
      sessionStorage.getItem("Vue_TripId") == null &&
      _self.$route.params.tripId == null
    ) {
      _self.$router.push("/HomePage");
    } else {
      _self.tripId =
        _self.$route.params.tripId != null
          ? _self.$route.params.tripId
          : sessionStorage.getItem("Vue_TripId");
      _self.GetData();
    }

    mySwiper = new Swiper(".swiper-container", {
      direction: "horizontal", // 垂直切换选项
      loop: false, // 循环模式选项
      observer: true, //修改swiper自己或子元素时，自动初始化swiper
      observeParents: true, //修改swiper的父元素时，自动初始化swiper
      // 如果需要分页器
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      on: {
        slideChange: function () {
          if (this.activeIndex != _self.selectDate) {
            _self.selectDate = this.activeIndex;
          }
        }
      }
    });

  },
  created() { }
};
</script>

<style lang="less" scoped>
.TripDetail {
  width: 100%;
  min-height: 100%;
  background-image: url("../assets/home-bg.png");
  background-repeat: no-repeat;
  background-size: 100% auto;
  background-color: #ddd;
  // padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  header {
    padding: 20px;
    box-sizing: border-box;
    width: 100%;
    display: flex;
    flex-direction: column;
    color: #eef5f9;

    .top {
      width: 100%;
      display: flex;
      align-items: center;
      letter-spacing: 2px;

      span:nth-of-type(1) {
        font-size: 24px !important;
        margin-right: 5px;
      }

      span:nth-of-type(2) {
        font-size: 24px !important;
        flex: 1;
        margin-right: 10px;
      }

      span:nth-of-type(3) {
        font-size: 24px !important;
        margin-right: 5px;
      }

      span:nth-of-type(4) {
        font-size: 24px !important;
      }
    }

    .center {
      margin-top: 30px;
      width: 100%;
      display: flex;
      box-sizing: border-box;
      flex-wrap: wrap;

      span:nth-of-type(1) {
        width: 100%;
        font-size: 36px;
        font-weight: bold;
        letter-spacing: 3px;
        margin-bottom: 15px;
      }

      span:nth-of-type(n + 2) {
        width: 50%;
        font-size: 24px;
        letter-spacing: 2px;
      }

      span:nth-of-type(n + 4) {
        margin-top: 20px;
      }
    }

    .bottom {
      margin-top: 30px;
      display: flex;
      padding: 15px 20px;
      background-color: #ffffff;
      border-radius: 10px;
      box-shadow: 0px 0px 9px 1px rgba(0, 0, 0, 0.35);
      box-sizing: border-box;

      div:nth-of-type(1) {
        flex: 1;
        margin-right: 25px;
        font-size: 24px;
        letter-spacing: 2px;
        color: #666666;
      }

      div:nth-of-type(2) {
        background-color: #167fef;
        border-radius: 10px;
        font-size: 24px;
        letter-spacing: 2px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 150px;

        a,
        a:link,
        a:visited,
        a:hover,
        a:active {
          color: white !important;
        }
      }
    }
  }

  .main {
    flex: 1;
    width: 100%;
    height: 100%;
    position: relative;

    .mainScroll {
      padding: 5px 20px;
      box-sizing: border-box;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      overflow-y: auto;

      .trip,
      .contact,
      .corp,
      .car,
      .guide {
        margin-bottom: 30px;
        background-color: #ffffff;
        box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.35);
        border-radius: 10px;
        padding: 20px;
        box-sizing: border-box;

        .title {
          border-bottom: 1px solid #ddd;
          padding-bottom: 25px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
        }

        .row {
          padding: 10px 0;
          border-bottom: 1px solid #ddd;
          display: flex;
          flex-direction: column;
          margin-top: 10px;

          span:nth-of-type(1) {
            font-size: 24px;
            letter-spacing: 3px;
            color: #999999;
          }

          span:nth-of-type(2) {
            margin-top: 20px;
            font-size: 36px;
            letter-spacing: 3px;
            color: #465865;
          }
        }
      }

      .trip {
        .title {
          span:nth-of-type(1) {
            font-size: 34px;
            margin-right: 5px;
            color: #35b0fd;
          }

          span:nth-of-type(2) {
            font-size: 34px;
            font-weight: bold;
            letter-spacing: 3px;
            line-height: 34px;
            color: #465865;
            flex: 1;
          }

          span:nth-of-type(3) {
            font-size: 34px;
            font-weight: bold;
            line-height: 34px;
            color: #fbe179;
          }
        }

        .calendar {
          padding: 20px 0;
          width: 100%;
          overflow-x: scroll;
          display: flex;
          flex-wrap: nowrap;

          .item {
            width: 100px;
            flex-shrink: 0;
            display: flex;
            flex-direction: column;
            margin: 0 5px;
            justify-content: center;
            align-items: center;

            .week {
              font-size: 30px;
              letter-spacing: 2px;
              color: #6e7d88;
            }

            .date {
              display: flex;
              justify-content: center;
              align-items: center;
              margin-top: 10px;
              width: 90px;
              height: 90px;
              font-size: 40px;
              letter-spacing: 3px;
              color: #999999;
              border-radius: 100%;
              box-sizing: border-box;
              position: relative;

              .iconfont {
                position: absolute;
                bottom: 0;
                font-size: 24px;
              }
            }

            .tripDate {
              color: #35b0fd !important;
            }

            .active {
              background-color: #35b0fd;
              color: #ffffff !important;

              .iconfont {
                color: #35b0fd !important;
              }
            }
          }
        }

        .swiper {
          margin-top: 10px;

          // height: 35vh;
          .swiper-container {
            height: 100%;
            width: 100%;

            .swiper-slide {
              height: 100%;
              margin-bottom: 5vh;
              // height: 32.5vh;
              // overflow-y: auto;

              .blue {
                color: #35b0fd !important;
              }

              .black {
                color: #465865 !important;
              }

              .item {
                display: flex;
                align-items: stretch;
                margin-top: 30px;
                box-sizing: border-box;
                position: relative;
                color: #999999;

                .line {
                  position: absolute;
                  top: 25px;
                  left: 22px;
                  width: 1px;
                  height: 130%;
                  border-right: 3px solid #ddd;
                  z-index: 99;
                }

                .iconfont {
                  font-size: 50px !important;
                  display: flex;
                  align-items: flex-start;
                  margin-right: 20px;
                  line-height: 50px;
                  z-index: 999;
                }

                .con {
                  flex: 1;
                  margin-right: 20px;
                  display: flex;
                  flex-direction: column;

                  span:nth-of-type(1) {
                    font-size: 36px;
                    letter-spacing: 2px;
                  }

                  span:nth-of-type(2) {
                    font-size: 30px;
                    margin-top: 10px;
                    letter-spacing: 2px;
                    color: #6e7d88;
                  }
                }

                .time {
                  margin-right: 10px;
                  font-size: 30px;
                  letter-spacing: 2px;
                  color: #6e7d88;
                  display: flex;
                  flex-direction: column;

                  span {
                    flex: 1 0 auto;
                    display: flex;
                    align-items: flex-end;
                  }
                }
              }
            }
          }
        }
      }

      .contact {
        .title {
          span:nth-of-type(1) {
            font-size: 34px;
            margin-right: 5px;
            color: #ffb22b;
          }

          span:nth-of-type(2) {
            font-size: 34px;
            font-weight: bold;
            letter-spacing: 3px;
            line-height: 34px;
            color: #465865;
            flex: 1;
          }

          span:nth-of-type(3) {
            font-size: 24px;
            color: #465865;
          }
        }

        .con {
          display: flex;
          flex-direction: column;

          span:nth-of-type(1) {
            margin-top: 40px;
            font-size: 24px;
            letter-spacing: 3px;
            color: #999999;
          }

          span:nth-of-type(2) {
            font-size: 36px;
            letter-spacing: 3px;
            color: #35b0fd;
            margin-top: 20px;
          }
        }
      }

      .guide {
        .title {
          span:nth-of-type(1) {
            font-size: 34px;
            margin-right: 5px;
            color: #ef9b23;
          }

          span:nth-of-type(2) {
            font-size: 34px;
            font-weight: bold;
            letter-spacing: 3px;
            line-height: 34px;
            color: #465865;
            flex: 1;
          }
        }
      }

      .car {
        .title {
          span:nth-of-type(1) {
            font-size: 34px;
            margin-right: 5px;
            color: #698fa2;
          }

          span:nth-of-type(2) {
            font-size: 34px;
            font-weight: bold;
            letter-spacing: 3px;
            line-height: 34px;
            color: #465865;
            flex: 1;
          }
        }
      }

      .corp {
        .title {
          span:nth-of-type(1) {
            font-size: 34px;
            margin-right: 5px;
            color: #167fef;
          }

          span:nth-of-type(2) {
            font-size: 34px;
            font-weight: bold;
            letter-spacing: 3px;
            line-height: 34px;
            color: #465865;
            flex: 1;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TripDetail.vue